// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"affdc3d0","209":"e84591e5","234":"51163158","343":"85f80455","744":"926661be","900":"30d4dd7a","922":"b33a7810","953":"0da6c600","966":"8f20a249"}[chunkId] + ".chunk.js";
};